import useHelcimReturn from "./useHelcimReturn";

/**
 * Mounts the Helcim card-return handler once, at the app root.
 *
 * It used to live in `DashboardLayout`, which meant a return landing anywhere
 * outside the dashboard (a login screen, a standalone payment page) dropped the
 * card attach and left the subscription pending forever. `App` is a class
 * component, so the hook needs this small function component to live in — and
 * mounting it in exactly one place keeps the attach from firing twice.
 */
export default function HelcimReturnWatcher() {
  useHelcimReturn();
  return null;
}
